import "./portfolio.scss"

export default function portfolio() {
  return (

   
    <div className="portfolio" id="portfolio">
      
        <h1 className="about" >About me</h1>
        <div className="container">
          <div className="left">
            <div className="skill">
              <h2>Skill</h2>
            </div>
            <div className="logo-skill">
              <div className="skill-1">
                <h3>LANGUAGES AND TOOLS</h3>
                <div className="container-logo">
                  <img className="logo" src="https://www.shubhporwal.me/_next/image?url=%2Fskills%2Fhtml.svg&w=64&q=75" alt="HTML"/>
                  <img className="logo" src="https://www.shubhporwal.me/_next/image?url=%2Fskills%2Fcss.svg&w=64&q=75" alt="HTML"/>
                  <img className="logo" src="https://www.shubhporwal.me/_next/image?url=%2Fskills%2Fjavascript.svg&w=64&q=75" alt="HTML"/>
                  <img className="logo" src="https://www.shubhporwal.me/_next/image?url=%2Fskills%2Fsass.svg&w=64&q=75" alt="HTML"/>
                  <img className="logo" src="https://www.shubhporwal.me/_next/image?url=%2Fskills%2Fnodejs.svg&w=64&q=75" alt="HTML"/>
                </div>
              </div>
               
              
              <div className="skill-1">
                <h3>LIBRARIES AND FRAMEWORKS</h3>
                <div className="container-logo">
                  <img className="logo" src="https://www.shubhporwal.me/_next/image?url=%2Fskills%2Freact.svg&w=64&q=75" alt="HTML"/>
                  <img className="logo" src="https://www.shubhporwal.me/_next/image?url=%2Fskills%2Fnextjs.svg&w=64&q=75" alt="HTML"/>
                  <img className="logo" src="https://www.shubhporwal.me/_next/image?url=%2Fskills%2Ftailwindcss.svg&w=64&q=75" alt="HTML"/>
                </div>
              </div>

              <div className="skill-1">
                <h3>Other</h3>
                <div className="container-logo">
                  <img className="logo" src="https://www.shubhporwal.me/_next/image?url=%2Fskills%2Fgit.svg&w=64&q=75" alt="HTML"/>
                  <img className="logo" src="https://upload.wikimedia.org/wikipedia/commons/f/fb/Adobe_Illustrator_CC_icon.svg" alt="HTML"/>
                  <img className="logo" src="https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg" alt="HTML"/>
                  <img className="logo" src="https://labs.mysql.com/common/logos/mysql-logo.svg?v2" alt="HTML"/>
                  <img className="logo" src="https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/postman-icon.png" alt="HTML"/>

                </div>
              </div>


            </div>    
          </div>
          <div className="right"> 
            <div className="text">
              <h4>As a multifaceted professional, I am a front-end developer, ceramicist, and economic tutor. My passion is to create captivating digital interfaces, shape clay into expressive art, and impart economic wisdom. My purpose is to infuse creativity into technology, artistry into ceramics, and knowledge into minds, enriching lives through these diverse avenues of expression.</h4>
            </div>
            <a href="https://drive.google.com/u/0/uc?id=1ji5SEqGujSXOZ9FJ5deJhghtbZbK0Ch6&export=download">Download CV</a>
          </div>
        </div>

     

    </div>
        
          
        
        
    
        

  
  )
}
